import types from '../types';

export const initialState = [];

export default function rbsPricingReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_RBS_PRICING:
            const rbsPricing = action.payload;
            if(action.payload !== null) {
                return rbsPricing;
            } else return state;
        default:
            return state;
    }
};
